/* t22-produkt.js — produktsidan i tema 22. Byggd 2026-10-06, omgjord 2026-10-08 efter Sadams val
   (spår 5 "Flikarna", köpdel 1 "Raderna"). Laddas av sections/t22-produkt.
   1. Galleriet: svep (scroll-snap), räknare, tummar (lodräta på dator), helskärm med zoom.
   2. Raderna: en rad per alternativ fälls ut till en lista; valet stänger listan. Listan visar mått
      ur custom.storleksguide och pris per värde. Pris, lager, frakt, knapptext, bild och adress
      (?variant=) följer valet. Storlek med flera värden måste väljas aktivt. Antal med − och +.
   3. Hitta min storlek: måttet jämförs med storleksguidens intervall (bara verifierade guider).
   4. Köpet: window.nrKombiLaggTill (assets/nr-kombi.js) lägger i och öppnar varukorgslådan;
      finns den inte postas formuläret som vanligt.
   5. Klistrig köprad i mobil när köpknappen är ur bild.
   6. Flikarna (sections/t22-produkt-info): tangentbord, länkar med data-till-flik öppnar en flik.
   7. Spara och Dela; Sparat och Nyligen sedda (sections/t22-produkt-slut), i webbläsarens minne.
   8. Shopifys rekommendationer hämtas till [data-t22-rek] (sections/t22-produkt-lista).
   9. Recensionsappen Vitals flyttas in i fliken Recensioner.
   Butiksdata skrivs med textContent, aldrig innerHTML (utom Shopifys egen sektions-HTML). */
(function () {
  'use strict';

  var slice = function (l) { return Array.prototype.slice.call(l); };
  function kr(oren) {
    var n = Math.round(oren) / 100;
    return n.toLocaleString('sv-SE', { maximumFractionDigits: n % 1 ? 2 : 0 }) + ' kr';
  }
  function lasLista(nyckel) {
    try { var x = JSON.parse(localStorage.getItem(nyckel) || '[]'); return Array.isArray(x) ? x : []; } catch (e) { return []; }
  }
  function sparaLista(nyckel, lista) { try { localStorage.setItem(nyckel, JSON.stringify(lista)); } catch (e) {} }

  function init(rot) {
    if (rot.dataset.klar) return;
    rot.dataset.klar = '1';
    var dataEl = rot.querySelector('[data-varianter]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { varianter: [], bilder: [] };
    var form = rot.querySelector('[data-form]');
    var idInput = rot.querySelector('[data-variant-id]');
    var antalIn = rot.querySelector('[data-antal-in]');
    var knapp = rot.querySelector('[data-lagg]');
    var fel = rot.querySelector('[data-fel]');
    var lager = rot.querySelector('[data-lager]');
    var fraktEl = rot.querySelector('[data-frakt]');
    var prisEl = rot.querySelector('[data-pris]');
    var grupper = slice(rot.querySelectorAll('[data-alt]'));
    var oppnare = slice(rot.querySelectorAll('[data-oppna]'));
    var klister = rot.querySelector('[data-klister]');
    var klisterKn = rot.querySelector('[data-klister-kn]');
    var klisterPris = rot.querySelector('[data-klister-pris]');
    var storlekNamn = (data.storlek || 'storlek').toLowerCase();
    var antal = 1;
    var korg = Number(data.korg) || 0;

    /* ---------- 1. Galleri ---------- */
    var spar = rot.querySelector('[data-spar]');
    var bilder = spar ? slice(spar.querySelectorAll('.t22p__bild')) : [];
    var nrEl = rot.querySelector('[data-nr]');
    var tummar = slice(rot.querySelectorAll('[data-till]'));
    var aktiv = 0;
    function visaBild(i, mjukt) {
      if (!spar || !bilder[i]) return;
      spar.scrollTo({ left: bilder[i].offsetLeft - spar.offsetLeft, behavior: mjukt === false ? 'auto' : 'smooth' });
      markera(i);
    }
    function markera(i) {
      aktiv = i;
      if (nrEl) nrEl.textContent = String(i + 1);
      tummar.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    if (spar && bilder.length) {
      var raf;
      spar.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(spar.scrollLeft / Math.max(1, spar.clientWidth));
          i = Math.max(0, Math.min(bilder.length - 1, i));
          if (i !== aktiv) markera(i);
        });
      }, { passive: true });
      tummar.forEach(function (t) { t.addEventListener('click', function () { visaBild(Number(t.getAttribute('data-till'))); }); });
      spar.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); visaBild(Math.min(bilder.length - 1, aktiv + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); visaBild(Math.max(0, aktiv - 1)); }
        if (e.key === 'Enter') { e.preventDefault(); ovOppna(aktiv); }
      });
      markera(0);
    }
    function visaMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < bilder.length; i++) {
        if (bilder[i].getAttribute('data-media') === String(mediaId)) { visaBild(i); return; }
      }
    }

    /* Helskärm: tryck på bilden eller Helskärm. Tryck på bilden i helskärm zoomar. */
    var ov = rot.querySelector('[data-ov]');
    var ovImg = rot.querySelector('[data-ov-img]');
    var ovBild = rot.querySelector('[data-ov-bild]');
    var ovNr = rot.querySelector('[data-ov-nr]');
    var ovI = 0, ovFran = null;
    function ovVisa(i) {
      var n = (data.bilder || []).length;
      if (!n) return;
      ovI = (i + n) % n;
      ovImg.src = data.bilder[ovI];
      ovNr.textContent = (ovI + 1) + ' / ' + n;
      ovBild.classList.remove('is-zoom');
    }
    function ovOppna(i) {
      if (!ov) return;
      ovFran = document.activeElement;
      ovVisa(i);
      ov.hidden = false;
      document.documentElement.classList.add('t22p-last');
      rot.querySelector('[data-ov-stang]').focus();
    }
    function ovStang() {
      if (!ov || ov.hidden) return;
      ov.hidden = true;
      document.documentElement.classList.remove('t22p-last');
      if (ovFran && ovFran.focus) ovFran.focus();
    }
    if (ov) {
      bilder.forEach(function (b) { b.addEventListener('click', function () { ovOppna(Number(b.getAttribute('data-z'))); }); });
      var zk = rot.querySelector('[data-zoom]');
      if (zk) zk.addEventListener('click', function () { ovOppna(aktiv); });
      rot.querySelector('[data-ov-stang]').addEventListener('click', ovStang);
      slice(rot.querySelectorAll('[data-ov-steg]')).forEach(function (b) {
        b.addEventListener('click', function () { ovVisa(ovI + Number(b.getAttribute('data-ov-steg'))); });
      });
      ovImg.addEventListener('click', function () { ovBild.classList.toggle('is-zoom'); });
      document.addEventListener('keydown', function (e) {
        if (ov.hidden) return;
        if (e.key === 'Escape') ovStang();
        if (e.key === 'ArrowRight') ovVisa(ovI + 1);
        if (e.key === 'ArrowLeft') ovVisa(ovI - 1);
      });
    }

    /* ---------- 2. Raderna ---------- */
    var altIndex = grupper.map(function (g) { return Number(g.getAttribute('data-alt')); });
    var valt = grupper.map(function (g) {
      var c = g.querySelector('[aria-checked="true"]');
      return c ? c.getAttribute('data-varde') : null;
    });
    /* Mått per storlek ur custom.storleksguide: första cellen = storleken, kolumnen data.guide.kol = måttet
       (Storlekskoll 2026-10-12: kroppsmåttet i cm, annars EU-skostorleken; förr alltid kolumn 2).
       Guidens storleksnamn matchas mot varianten oavsett skrivsätt: "S (Small)", "S / M", "Small / Medium",
       "X-Small (XS)" och "S (16–19 cm)" hittar alla rätt variant. */
    var guideRad = {};
    var guideRader = [];
    var kol = data.guide && data.guide.kol > -1 ? data.guide.kol : 1;
    function tal(t) { return parseFloat(String(t).replace(',', '.')); }
    function nyckel(t) {
      return String(t).toLowerCase().replace(/xxx-large/g, 'xxxl').replace(/xx-large/g, 'xxl').replace(/x-large/g, 'xl')
        .replace(/x-small/g, 'xs').replace(/large/g, 'l').replace(/medium/g, 'm').replace(/small/g, 's')
        .replace(/(\d)\s*[-–]\s*(\d)/g, '$1/$2').replace(/\s+/g, '');
    }
    function nycklar(t) {
      t = String(t).trim();
      var k = [nyckel(t), nyckel(t.split('(')[0])];
      var p = t.match(/\(([^)]*)\)/); if (p) k.push(nyckel(p[1]));
      var d = t.match(/^\d+\/(\D.*)$/); if (d) k.push(nyckel(d[1]));
      return k.filter(function (x) { return x; });
    }
    function radFor(val) {
      var k = nycklar(val);
      for (var i = 0; i < k.length; i++) if (guideRad[k[i]]) return guideRad[k[i]];
      return null;
    }
    if (data.guide && data.guide.r) {
      data.guide.r.forEach(function (rad) {
        if (!rad || rad.length <= kol) return;
        var cell = String(rad[kol]).replace(/\s*cm\s*$/i, '').trim();
        var post = { s: String(rad[0]).trim(), text: cell.replace(/\s*-\s*plus$/i, '+').replace(/\s*-\s*/g, '–') };
        var m = cell.match(/(\d+(?:[.,]\d+)?)\s*[–\-\/]\s*(\d+(?:[.,]\d+)?|plus)/i);
        if (m) { post.min = tal(m[1]); post.max = /plus/i.test(m[2]) ? Infinity : tal(m[2]); guideRader.push(post); }
        nycklar(post.s).forEach(function (k) { if (!(k in guideRad)) guideRad[k] = post; });
      });
    }
    function mattText(val) {
      var r = radFor(val);
      if (!r || kol === 0 || /\d\s*cm/i.test(val)) return '';
      return data.guide.etikett + ' ' + r.text + (data.guide.cm ? ' cm' : '');
    }
    function passar(v, val, hoppa) {
      for (var k = 0; k < altIndex.length; k++) {
        if (k === hoppa) continue;
        if (val[k] !== null && v.o[altIndex[k]] !== val[k]) return false;
      }
      return true;
    }
    function hitta(val) {
      for (var i = 0; i < data.varianter.length; i++) {
        var v = data.varianter[i];
        if (val.every(function (x) { return x !== null; }) && passar(v, val, -1)) return v;
      }
      return null;
    }
    function saknas() {
      for (var j = 0; j < valt.length; j++) if (valt[j] === null) return j;
      return -1;
    }
    function oppnaLista(j, pa) {
      var g = grupper[j], o = oppnare[j];
      if (!g || !o) return;
      g.hidden = !pa;
      o.setAttribute('aria-expanded', pa ? 'true' : 'false');
    }
    function satt(el, text) { if (el) el.textContent = text; }

    function uppdatera(franKlick) {
      /* Listorna: mått, pris eller Slutsåld per värde, givet övriga val. */
      grupper.forEach(function (g, j) {
        slice(g.querySelectorAll('[data-varde]')).forEach(function (b) {
          var val = b.getAttribute('data-varde');
          var kand = data.varianter.filter(function (v) { return v.o[altIndex[j]] === val && passar(v, valt, j); });
          var ok = kand.filter(function (v) { return v.ok; });
          var prisText = '';
          if (!ok.length) prisText = 'Slutsåld';
          else {
            var p = ok.map(function (v) { return v.pris; });
            var min = Math.min.apply(null, p), max = Math.max.apply(null, p);
            prisText = min === max ? kr(min) : 'Från ' + kr(min);
          }
          b.classList.toggle('is-slut', !ok.length);
          satt(b.querySelector('[data-vpris]'), prisText);
          if (g.hasAttribute('data-storlek')) satt(b.querySelector('[data-matt]'), mattText(val));
          b.setAttribute('aria-checked', valt[j] === val ? 'true' : 'false');
          b.tabIndex = valt[j] === val || (valt[j] === null && b === g.querySelector('[data-varde]')) ? 0 : -1;
        });
        var o = oppnare[j];
        if (o) {
          var vEl = o.querySelector('[data-valt]');
          var txt = valt[j] === null ? 'Välj' : valt[j];
          if (valt[j] !== null) slice(g.querySelectorAll('[data-varde]')).forEach(function (b) { if (b.getAttribute('data-varde') === valt[j] && b.getAttribute('data-visa')) txt = b.getAttribute('data-visa'); });
          if (valt[j] !== null && g.hasAttribute('data-storlek') && mattText(valt[j])) txt += ' · ' + mattText(valt[j]);
          satt(vEl, txt);
          if (valt[j] !== null) o.classList.remove('is-markerad');
        }
      });

      var luck = saknas();
      var v = luck === -1 ? hitta(valt) : null;
      /* Produktsida per produkt 2026-10-12: färgens bild visas direkt när färgen väljs, även innan storleken är vald. */
      if (franKlick && !v) {
        for (var mi = 0; mi < data.varianter.length; mi++) {
          var mv = data.varianter[mi];
          if (mv.media && valt.every(function (x, j) { return x === null || mv.o[altIndex[j]] === x; })) { visaMedia(mv.media); break; }
        }
      }
      var text, kortText, av = false, valj = false;
      lager.textContent = '';
      function lagerRad(prickKlass, ord, resten) {
        var p = document.createElement('i'); p.className = 't22p__prick' + (prickKlass ? ' ' + prickKlass : ''); lager.appendChild(p);
        var s = document.createElement('span');
        if (ord) { var b = document.createElement('b'); b.textContent = ord; s.appendChild(b); s.appendChild(document.createTextNode(' ')); }
        s.appendChild(document.createTextNode(resten || ''));
        lager.appendChild(s);
      }
      var nagonOk = data.varianter.some(function (x) { return x.ok; });
      if (!nagonOk) {
        text = kortText = 'Slutsåld'; av = true;
        lagerRad('t22p__prick--slut', 'Slutsåld just nu.', 'Fråga oss på info@haraka.se.');
      } else if (luck !== -1) {
        var namn = (oppnare[luck] ? oppnare[luck].querySelector('span').textContent : storlekNamn).trim().toLowerCase();
        text = kortText = 'Välj ' + namn; valj = true;
        var iLager = data.varianter.some(function (x) { return x.ok && x.lager; });
        var slutVarden = [];
        if (grupper.length === 1) {
          slice(grupper[0].querySelectorAll('[data-varde].is-slut')).forEach(function (b) { slutVarden.push(b.getAttribute('data-varde')); });
        }
        var extra = slutVarden.length ? slutVarden.join(', ') + (slutVarden.length > 1 ? ' är slutsålda. ' : ' är slutsåld. ') : '';
        lagerRad('', '', extra + (data.leverans || ''));
        satt(prisEl, prisEl.getAttribute('data-fran') || prisEl.textContent);
      } else if (!v) {
        text = kortText = 'Finns inte i den kombinationen'; av = true;
      } else {
        idInput.value = v.id;
        satt(prisEl, kr(v.pris));
        satt(klisterPris, kr(v.pris));
        if (v.ok) {
          text = 'Lägg i varukorg · ' + kr(v.pris * antal);
          kortText = 'Lägg i varukorg';
          // Framtidstemat 2026-10-11: ärlig knapphet (Hormozi kap 11 och 12), bara ur verkligt saldo 1 till 3.
          if (v.fa) lagerRad('t22p__prick--fa', 'Få kvar i det här valet.', data.leverans || '');
          else lagerRad('', '', data.leverans || '');
        } else {
          text = kortText = 'Slutsåld'; av = true;
          lagerRad('t22p__prick--slut', 'Slutsåld i det här valet.', 'Välj en annan ' + storlekNamn + ' eller fråga oss på info@haraka.se.');
        }
        if (franKlick) {
          visaMedia(v.media);
          try {
            var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          } catch (e) {}
        }
      }
      /* Frakten räknad på valet */
      if (fraktEl && data.grans) {
        /* Korgens summa (efter rabatt, samma mått som varukorgen) räknas med: korg kommer från sidan och
           uppdateras av /cart.js nedan. */
        var summa = (v && v.ok ? v.pris * antal : 0) + korg;
        if (v && v.ok) {
          fraktEl.textContent = summa >= data.grans
            ? (korg > 0 ? 'Fri frakt med det som ligger i varukorgen.' : 'Fri frakt på den här.')
            : 'Frakt ' + data.frakt + ' kr. ' + kr(data.grans - summa) + ' kvar till fri frakt.';
        } else if (korg >= data.grans) {
          fraktEl.textContent = 'Fri frakt, din varukorg är över ' + kr(data.grans) + '.';
        } else {
          fraktEl.textContent = 'Frakt ' + data.frakt + ' kr, fri från ' + kr(data.grans) + '.' + (korg > 0 ? ' ' + kr(data.grans - korg) + ' kvar med din varukorg.' : '');
        }
      }
      if (knapp) {
        knapp.disabled = av;
        knapp.classList.toggle('is-valj', valj);
        satt(knapp.querySelector('[data-lagg-text]'), text);
      }
      if (klisterKn) {
        klisterKn.disabled = av;
        klisterKn.classList.toggle('is-valj', valj);
        satt(klisterKn.querySelector('[data-klister-text]'), kortText);
      }
    }
    if (prisEl) prisEl.setAttribute('data-fran', prisEl.textContent);

    oppnare.forEach(function (o, j) {
      o.addEventListener('click', function () { oppnaLista(j, grupper[j].hidden); });
    });
    grupper.forEach(function (g, j) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-varde]');
        if (!b) return;
        valt[j] = b.getAttribute('data-varde');
        if (fel) fel.hidden = true;
        oppnaLista(j, false);
        uppdatera(true);
        if (oppnare[j]) oppnare[j].focus({ preventScroll: true });
      });
      /* Pilarna flyttar mellan värdena (radiogrupp) */
      g.addEventListener('keydown', function (e) {
        if (['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].indexOf(e.key) === -1) return;
        var knappar = slice(g.querySelectorAll('[data-varde]'));
        var i = knappar.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        var n = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? i + 1 : i - 1;
        knappar[(n + knappar.length) % knappar.length].focus();
      });
    });

    /* Antal */
    var antalVisa = rot.querySelector('[data-antal-visa]');
    slice(rot.querySelectorAll('[data-antal]')).forEach(function (b) {
      b.addEventListener('click', function () {
        antal = Math.max(1, Math.min(20, antal + Number(b.getAttribute('data-antal'))));
        satt(antalVisa, String(antal));
        if (antalIn) antalIn.value = antal;
        uppdatera(false);
      });
    });

    if (form) uppdatera(false);

    /* Korgens aktuella summa (sidan kan ligga i webbläsarens cache) */
    if (form && fraktEl && data.grans && window.fetch) {
      fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.total_price === 'number' && c.total_price !== korg) { korg = c.total_price; uppdatera(false); } })
        .catch(function () {});
    }

    /* ---------- 3. Hitta min storlek ---------- */
    var rekIn = rot.querySelector('[data-rek-in]'), rekUt = rot.querySelector('[data-rek-ut]');
    var storlekJ = grupper.map(function (g) { return g.hasAttribute('data-storlek'); }).indexOf(true);
    if (rekIn && rekUt && guideRader.length && storlekJ !== -1) {
      var rekStart = rekUt.getAttribute('data-start') || rekUt.textContent;
      var enhet = function (r) { return (data.guide.sko ? 'EU ' : '') + r.text + (data.guide.cm ? ' cm' : ''); };
      var knappFor = function (r) {
        return slice(grupper[storlekJ].querySelectorAll('[data-varde]')).filter(function (b) { return radFor(b.getAttribute('data-varde')) === r; })[0];
      };
      var namn = function (r) { var b = knappFor(r); return b ? (b.getAttribute('data-visa') || b.getAttribute('data-varde')) : r.s; };
      rekIn.addEventListener('input', function () {
        var c = tal(rekIn.value);
        if (!(c > 0)) { rekUt.textContent = rekStart; return; }
        var hit = guideRader.filter(function (r) { return c >= r.min && c <= r.max; });
        var lagst = Math.min.apply(null, guideRader.map(function (r) { return r.min; }));
        var hogst = Math.max.apply(null, guideRader.map(function (r) { return r.max; }));
        if (!hit.length) {
          if (c < lagst) { rekUt.textContent = 'Mindre än minsta storleken (' + enhet(guideRader.filter(function (r) { return r.min === lagst; })[0]) + '). Fråga oss, så hjälper vi dig.'; return; }
          if (c > hogst) { rekUt.textContent = 'Större än största storleken (' + enhet(guideRader.filter(function (r) { return r.max === hogst; })[0]) + '). Fråga oss, så hjälper vi dig.'; return; }
          /* Lucka i tillverkarens tabell: visa storlekarna på båda sidor. */
          var under = guideRader.filter(function (r) { return r.max < c; }).sort(function (a, b) { return b.max - a.max; })[0];
          var over = guideRader.filter(function (r) { return r.min > c; }).sort(function (a, b) { return a.min - b.min; })[0];
          hit = [under, over];
        }
        if (hit.length > 1) {
          var regel = data.guide.mellan ? ' ' + data.guide.mellan : ' Fråga oss, så hjälper vi dig välja.';
          rekUt.textContent = (hit.length === 2 ? 'Mellan ' + namn(hit[0]) + ' (' + enhet(hit[0]) + ') och ' + namn(hit[1]) + ' (' + enhet(hit[1]) + ').'
            : 'Måttet passar enligt tillverkaren ' + hit.map(namn).join(', ') + '.') + regel;
          return;
        }
        var b = knappFor(hit[0]);
        if (!b) { rekUt.textContent = 'Din storlek enligt tillverkaren: ' + hit[0].s + '. Den säljer vi inte här, fråga oss.'; return; }
        rekUt.textContent = 'Din storlek: ' + namn(hit[0]) + (/\d\s*cm/i.test(namn(hit[0])) ? '' : ' (' + enhet(hit[0]) + ')') + '. Vald.';
        valt[storlekJ] = b.getAttribute('data-varde');
        uppdatera(true);
      });
    }

    /* ---------- 4. Köpet ---------- */
    function pekaPaVal() {
      var luck = saknas();
      if (luck === -1) return false;
      var o = oppnare[luck];
      oppnaLista(luck, true);
      if (o) {
        o.classList.add('is-markerad');
        o.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var forsta = grupper[luck].querySelector('[data-varde]:not(.is-slut)') || grupper[luck].querySelector('[data-varde]');
        if (forsta) setTimeout(function () { forsta.focus({ preventScroll: true }); }, 350);
      }
      return true;
    }
    if (form) form.addEventListener('submit', function (e) {
      if (pekaPaVal()) { e.preventDefault(); return; }
      if (typeof window.nrKombiLaggTill !== 'function') return; /* vanlig post */
      e.preventDefault();
      if (knapp.disabled) return;
      var s = knapp.querySelector('[data-lagg-text]'), t = s.textContent;
      knapp.disabled = true; knapp.classList.add('is-laddar'); s.textContent = 'Lägger i …';
      window.nrKombiLaggTill(idInput.value, antal)
        .then(function () { s.textContent = 'Tillagd'; setTimeout(function () { s.textContent = t; }, 1600); })
        .catch(function (err) {
          s.textContent = t;
          if (fel) { fel.textContent = (err && err.message) || 'Det gick inte att lägga i varan. Försök igen.'; fel.hidden = false; }
        })
        .then(function () { knapp.disabled = false; knapp.classList.remove('is-laddar'); });
    });
    if (klisterKn) klisterKn.addEventListener('click', function () {
      if (pekaPaVal()) return;
      if (form.requestSubmit) form.requestSubmit(knapp); else knapp.click();
    });

    /* ---------- 5. Klistrig köprad ---------- */
    if (klister && knapp && 'IntersectionObserver' in window) {
      var syns = true, slut = false;
      var satt2 = function () {
        var visa = !syns && !slut;
        klister.classList.toggle('is-synlig', visa);
        klister.setAttribute('aria-hidden', visa ? 'false' : 'true');
        if (klisterKn) klisterKn.tabIndex = visa ? 0 : -1;
      };
      new IntersectionObserver(function (en) {
        syns = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
        satt2();
      }).observe(knapp);
      var fot = document.querySelector('.t22-fot');
      if (fot) new IntersectionObserver(function (en) { slut = en[0].isIntersecting; satt2(); }).observe(fot);
    }

    /* ---------- 7. Spara och Dela ---------- */
    var handle = rot.getAttribute('data-handle');
    var sparaKn = rot.querySelector('[data-spara]');
    function ritaSpara() {
      if (!sparaKn) return;
      var p = lasLista('t22-sparade').indexOf(handle) !== -1;
      sparaKn.setAttribute('aria-pressed', p ? 'true' : 'false');
      var t = sparaKn.querySelector('[data-spara-text]') || sparaKn;
      t.textContent = p ? 'Sparad' : 'Spara';
    }
    /* Hjärtan på kort (t22-sparat.js) och andra flikar skriver samma lista */
    document.addEventListener('t22-sparat', ritaSpara);
    window.addEventListener('storage', function (e) { if (e.key === 't22-sparade') ritaSpara(); });
    if (sparaKn && handle) {
      ritaSpara();
      sparaKn.addEventListener('click', function () {
        var l = lasLista('t22-sparade'), i = l.indexOf(handle);
        if (i === -1) l.unshift(handle); else l.splice(i, 1);
        sparaLista('t22-sparade', l.slice(0, 24));
        ritaSpara();
        rader();
      });
    }
    var delaKn = rot.querySelector('[data-dela]');
    if (delaKn) delaKn.addEventListener('click', function () {
      var url = location.origin + location.pathname;
      var titel = (rot.querySelector('.t22p__namn') || {}).textContent || document.title;
      if (navigator.share) { navigator.share({ title: titel, url: url }).catch(function () {}); return; }
      try { navigator.clipboard.writeText(url).then(function () { delaKn.textContent = 'Länken kopierad'; }); } catch (e) {}
    });
    if (handle) {
      var sedda = lasLista('t22-sedda').filter(function (h) { return h !== handle; });
      sedda.unshift(handle);
      sparaLista('t22-sedda', sedda.slice(0, 12));
    }
  }

  /* ---------- 6. Flikar ---------- */
  function flikar(rot) {
    if (rot.dataset.klar) return;
    rot.dataset.klar = '1';
    var knappar = slice(rot.querySelectorAll('[data-flik]'));
    var paneler = slice(rot.querySelectorAll('[data-panel]'));
    rot.classList.add('har-js');
    function oppna(namn, fokus) {
      var finns = knappar.some(function (k) { return k.getAttribute('data-flik') === namn; });
      if (!finns) return false;
      knappar.forEach(function (k) {
        var pa = k.getAttribute('data-flik') === namn;
        k.setAttribute('aria-selected', pa ? 'true' : 'false');
        k.tabIndex = pa ? 0 : -1;
        if (pa && fokus) k.focus();
      });
      paneler.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== namn; });
      return true;
    }
    rot.t22Oppna = oppna;
    knappar.forEach(function (k, i) {
      k.addEventListener('click', function () { oppna(k.getAttribute('data-flik')); });
      k.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = i + 1;
        if (e.key === 'ArrowLeft') n = i - 1;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = knappar.length - 1;
        if (n === null) return;
        e.preventDefault();
        var mal = knappar[(n + knappar.length) % knappar.length];
        oppna(mal.getAttribute('data-flik'), true);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var l = e.target.closest('[data-till-flik]');
    if (!l) return;
    var rot = document.querySelector('[data-t22-flikar]');
    if (!rot || !rot.t22Oppna) return;
    if (rot.t22Oppna(l.getAttribute('data-till-flik'))) {
      e.preventDefault();
      rot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ---------- 7b. Sparat och Nyligen sedda ---------- */
  var cache = {};
  function hamta(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[h];
  }
  function kort(p) {
    var d = document.createElement('div'); d.className = 't22-kort';
    var a = document.createElement('a'); a.className = 't22-kort__l'; a.href = p.url;
    var b = document.createElement('div'); b.className = 't22-kort__bild';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=400';
      img.alt = p.title; img.loading = 'lazy'; img.width = 400; img.height = 400;
      b.appendChild(img);
    }
    a.appendChild(b);
    if (p.vendor) { var m = document.createElement('span'); m.className = 't22-kort__marke'; m.textContent = p.vendor; a.appendChild(m); }
    var n = document.createElement('span'); n.className = 't22-kort__namn'; n.textContent = p.title; a.appendChild(n);
    var pr = document.createElement('span'); pr.className = 't22-kort__pris';
    pr.textContent = (p.price_varies ? 'Från ' : '') + kr(p.price) + (p.available ? '' : ' · Slutsåld'); a.appendChild(pr);
    d.appendChild(a);
    var k = document.createElement('a'); k.className = 't22-lagg'; k.href = p.url;
    var ks = document.createElement('span'); ks.textContent = 'Till produkten'; k.appendChild(ks);
    d.appendChild(k);
    return d;
  }
  function ritaRad(el, handles) {
    if (!el) return;
    if (!handles.length) { el.hidden = true; el.textContent = ''; return; }
    Promise.all(handles.map(hamta)).then(function (lista) {
      lista = lista.filter(Boolean);
      el.textContent = '';
      if (!lista.length) { el.hidden = true; return; }
      var h = document.createElement('div'); h.className = 't22pl__h';
      var h2 = document.createElement('h2'); h2.textContent = el.getAttribute('data-rubrik'); h.appendChild(h2);
      el.appendChild(h);
      var r = document.createElement('div'); r.className = 't22-rutor t22pl__rutor';
      lista.forEach(function (p) { r.appendChild(kort(p)); });
      el.appendChild(r);
      el.hidden = false;
    });
  }
  function rader() {
    var sedda = document.querySelector('[data-t22-sedda]');
    var sparade = document.querySelector('[data-t22-sparade]');
    var nu = sedda ? sedda.getAttribute('data-handle') : '';
    ritaRad(sparade, lasLista('t22-sparade').filter(function (h) { return h !== nu; }).slice(0, 4));
    ritaRad(sedda, lasLista('t22-sedda').filter(function (h) { return h !== nu; }).slice(0, 4));
  }

  /* ---------- 8. Rekommendationer ---------- */
  function rek() {
    slice(document.querySelectorAll('[data-t22-rek]')).forEach(function (el) {
      if (el.dataset.hamtad) return;
      el.dataset.hamtad = '1';
      fetch(el.getAttribute('data-t22-rek'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          var ny = d.querySelector('.t22pl');
          if (ny && ny.querySelector('.t22-kort')) el.replaceWith(ny); else el.remove();
        })
        .catch(function () { el.remove(); });
    });
  }

  /* ---------- 9. Recensionsappen Vitals ----------
     Appen lägger sin recensionsruta (#vitals-end-section) sist i sidan. Den flyttas in i fliken
     Recensioner så att det finns en enda recensionsplats; temats e-postformulär döljs då. */
  function vitals() {
    var mal = document.getElementById('t22-recensioner');
    if (!mal) return;
    var forsok = 0;
    (function leta() {
      var v = document.getElementById('vitals-end-section');
      if (v && v.innerText.trim()) {
        var hem = document.createElement('div'); hem.className = 't22pi__vitals';
        hem.appendChild(v); mal.appendChild(hem); mal.classList.add('har-vitals');
        return;
      }
      if (++forsok < 60) setTimeout(leta, 500);
    })();
  }

  function start() {
    slice(document.querySelectorAll('[data-t22p]')).forEach(init);
    slice(document.querySelectorAll('[data-t22-flikar]')).forEach(flikar);
    rek();
    rader();
    vitals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
